if (!customElements.get('customer-logo-carousel')) {
  customElements.define('customer-logo-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.customer-logos__track');
      this.controls = this.querySelector('.customer-logos__controls');
      this.progress = this.querySelector('[data-progress]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), {...options, passive: true});
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.resize = new ResizeObserver(() => { this.update(); this.schedule(); });
      this.resize.observe(this.track);
      this.intersection = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.schedule(); });
      this.intersection.observe(this);
      this.update();
    }
    update() {
      this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = this.maximum < 2;
      const progress = this.track.scrollWidth ? Math.min(1, Math.max(0, (this.track.clientWidth + this.track.scrollLeft) / this.track.scrollWidth)) : 1;
      this.progress?.style.setProperty('--scroll-progress', progress);
      this.previous.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= this.maximum - 2;
    }
    move(direction, automatic = false) {
      const item = this.track.firstElementChild;
      if (!item) return;
      const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const left = automatic && this.track.scrollLeft >= this.maximum - 2 ? 0 : this.track.scrollLeft + direction * step;
      this.track.scrollTo({left, behavior: this.motion.matches ? 'instant' : 'smooth'});
    }
    schedule() {
      clearInterval(this.timer);
      if (this.dataset.autoplay !== 'true' || this.hovered || this.focused || !this.visible || document.hidden || this.motion.matches || this.maximum < 2) return;
      this.timer = setInterval(() => this.move(1, true), 4000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
    }
  });
}
